module.exports = __webpack_public_path__ + "static/media/level2.38be2053.png";